
export const buildTestIdFromStr = (prefixTestId, componentPrefix, str) => {
  return [prefixTestId, componentPrefix, str].join(" ").trim().toLowerCase().split(" ").join("-")
};
